import { render, staticRenderFns } from "./employee.vue?vue&type=template&id=14999f54&scoped=true"
import script from "./employee.vue?vue&type=script&lang=js"
export * from "./employee.vue?vue&type=script&lang=js"
import style0 from "./employee.vue?vue&type=style&index=0&id=14999f54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14999f54",
  null
  
)

export default component.exports